/**
 * Triggers a media download in the browser from a given URL.
 * Infers the filename from the URL path if not explicitly provided.
 *
 * @param url - The URL of the file to download
 * @param filename - Optional filename override; defaults to the last segment of the URL path
 */
export async function downloadMedia(url: string, filename?: string): Promise<void> {
    const name = filename ?? url.split('/').pop() ?? 'download';

    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache', // This is import since chrome or browsers sometimes cache the responses when image are loaded using non-cors request such as displaying it using <img /> tag
    });
    const blob = await response.blob();

    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = name;
    anchor.target = '_blank';
    anchor.click();

    URL.revokeObjectURL(objectUrl);
}
